import { createDecorator } from '../../../platform/instantiation/common/instantiation.js';
const IMarkerDecorationsService = ( createDecorator('markerDecorationsService'));
export { IMarkerDecorationsService };
